module.exports = __webpack_public_path__ + "img/knowledge-base.e98e00b5.svg";